import { render } from "./doctor-info.vue?vue&type=template&id=60c14328&scoped=true"
import script from "./doctor-info.vue?vue&type=script&lang=js"
export * from "./doctor-info.vue?vue&type=script&lang=js"

import "./doctor-info.vue?vue&type=style&index=0&id=60c14328&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c14328"]])

export default __exports__